const questions = [
  {
    title: "آیا استفاده از خدمات DNS ابری رایگان است؟",
    answer:
      "بله. برای خرید DNS آبالون نیازی به پرداخت هیچ‌گونه هزینه‌ای ندارید و سرویس DNS ابری آبالون کاملا رایگان و بدون هرگونه محدودیت است. به عبارت دیگر هیچ محدودیتی در تعداد رکوردها، تعداد درخواست‌های ارسال شده به سمت سرورها و سرعت پاسخگویی به درخواست‌ها وجود ندارد.",
  },
  {
    title:
      "در حال حاضر دامنه‌های من روی DNS‌ دیگری است. آیا می‌توانم به سادگی دامنه‌های خود را به DNS رایگان آبالون منتقل کنم؟",
    answer:
      "بله. کافی‌ست وارد پنل کاربری آبالون شوید و از منوی «محافظت ابری»، دامنه مورد نظر خود را اضافه کنید. سپس به پنل وب‌سایتی که دامنه را از آن خریداری کرده‌اید مراجعه کرده و اطلاعات سرورهای آبالون را وارد نمایید.",
  },
  {
    title: "خدمات DNS ابری آبالون چه تفاوتی با سایر DNSها دارد؟",
    answer:
      "با کمک DNS ابری آبالون می‌توانید رکوردهای مرتبط با دامنه‌های خود را به سادگی و رایگان مدیریت کنید و به این منظور نیازی به طی کردن فرایند پیچیده راه‌اندازی و مدیریت سرورهای DNS‌ ندارید. علاوه بر این به لطف سرورهای متعدد در سراسر ایران و جهان، در دسترس بودن همیشگی سرویس DNS‌ ابری تضمین می‌شود.",
  },
];

const PopularServices = [
  {
    title: "سرور ابری",
    desc: "سرور ابری راهکاری ساده و سریع برای راه‌اندازی زیرساخت ابری است. با این سرویس طی مدت تنها چند دقیقه یک سرور قدرتمند با سیستم‌عامل دلخواه شما در اختیارتان قرار می‌گیرد.",
    logo: "VPS-Service.svg",
    route: "/vps",
    imgAlt: "سرور ابری آبالون",
    imgTitle: "سرور ابری آبالون",
  },
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری تمامی قابلیت‌های یک دیتاسنتر فیزیکی را روی محیط ابری در اختیارتان قرار می‌دهد. با این سرویس می‌توانید به تعداد نامحدود سرور مجازی را ساخته و مدیریت نمایید.",
    logo: "VPC-Service.svg",
    route: "/vpc",
    imgAlt: "دیتاسنتر ابری آبالون",
    imgTitle: "دیتاسنتر ابری آبالون",
  },
  {
    title: "سرویس مدیریت شده",
    desc: "تحت سرویس مدیریت‌شده، طراحی معماری ابری زیرساخت‌های مورد نیازتان را به آبالون می‌سپارید و نیازهای تخصصی حوزه ابری سازمان خود را به آبالون برون‌سپاری می‌کنید.",
    logo: "ManagedService-Service.svg",
    route: "/manageservices",
    imgAlt: "سرویس مدیریت شده آبالون",
    imgTitle: "سرویس مدیریت شده آبالون",
  },
  {
    title: "CDN ابری",
    desc: "سرویس شبکه توزیع محتوا (CDN) محتوای وب‌سایت شما را با سرعت بالا و تاخیر پایین به دست کاربران می‌رساند. با CDN ، امنیت و کیفیت سئو خود را بهبود دهید و در هزینه پهنای باند سرورهای خود صرفه‌جویی کنید.",
    logo: "CloudGuard-Service.svg",
    route: "/cdn",
    imgAlt: "CDN ابری آبالون",
    imgTitle: "CDN ابری آبالون",
  },
];

const dnsUses = [
  {
    img: "responseDelay.svg",
    title: "تاخیر بسیار پایین پاسخگویی",
    desc: "سرورهای آبالون پاسخ درخواست‌های DNS‌ را در کمترین زمان و با پایین‌ترین تاخیر ارائه می‌کنند.",
    imgAlt: "تاخیر بسیار پایین DNS ابری",
    imgTitle: "تاخیر بسیار پایین DNS ابری",
  },
  {
    img: "unlimitedDomain.svg",
    title: "تعداد نامحدود رکورد دامنه",
    desc: "برای تعریف رکوردهای خود در خدمات DNS ابری هیچ محدودیتی در تعداد ندارید.",
    imgAlt: "تعریف بی‌نهایت رکورد در DNS ابری",
    imgTitle: "تعریف بی‌نهایت رکورد در DNS ابری",
  },
  {
    img: "anyCast.svg",
    title: "معماری Anycast",
    desc: "با کمک این معماری، پاسخ درخـواست‌های DNS‌ از نـزدیک‌تـرین پاپ‌سایت داده می‌شود.",
    imgAlt:
      "پاسخ به درخواست‌های DNS ابری از نزدیک‌ترین پاپ‌سایت به کمک Anycast",
    imgTitle: "پاسخ به درخواست DNS ابری از نزدیک‌ترین پاپ‌سایت با Anycast",
  },
  {
    img: "noLimit.svg",
    title: "بدون محدودیت تعداد درخواست",
    desc: "این سرویس در هر لحظه می‌تواند میلیون‌ها درخواست DNS‌ را مدیریت کرده و پاسخ دهد.",
    imgAlt: "DNS رایگان بدون محدودیت در تعداد درخواست‌ها",
    imgTitle: "DNS رایگان بدون محدودیت به درخواست‌ها",
  },
];

const serviceFeatures = [
  {
    title: "استفاده کاملا رایگان",
    desc: "تمامی فرایند افزودن دامنه و استفاده از خدمات DNS ابری آبالون کاملا رایگان است.",
    logo: "Feature-1.svg",
    imgAlt: "DNS رایگان",
    imgTitle: "DNS رایگان",
  },
  {
    title: "سرورهایی در ایران و جهان",
    desc: "سرویس DNS ابری با سرورهایی در سراسر جهان، از تمامی دنیا و به صورت دائمی در دسترس است.",
    logo: "Feature-2.svg",
    imgAlt: "سرورهای جهانی DNS ابری آبالون",
    imgTitle: "سرورهای جهانی DNS ابری آبالون",
  },
  {
    title: "پشتیبانی از رکوردهای رایج",
    desc: "DNS ابری آبالون از رکوردهای رایج شامل TXT ،MX ،NS ،CNAME، AAAA ،A و … پشتیبانی می‌کند.",
    logo: "Feature-3.svg",
    imgAlt: "DNS ابری با پشتیبانی از رکوردهای رایج",
    imgTitle: "DNS ابری با پشتیبانی از رکوردهای رایج",
  },
  {
    title: "آپ‌تایم ۱۰۰ درصد",
    desc: "حداکثر آپ‌تایم، هرگونه نگرانی از دسترس خارج شدن سرویس DNS را رفع می‌کند.",
    logo: "Feature-4.svg",
    imgAlt: "آپ‌تایم صددرصد DNS ابری",
    imgTitle: "آپ‌تایم صددرصد DNS ابری",
  },
];
export default { questions, PopularServices, dnsUses, serviceFeatures };
